import { render, staticRenderFns } from "./TrailerRentalFlatbed.vue?vue&type=template&id=44ef8370&"
import script from "./TrailerRentalFlatbed.vue?vue&type=script&lang=js&"
export * from "./TrailerRentalFlatbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports